<template>
  <div>
    <v-card class="share-form-menu">
      <v-card-title>
        <v-spacer></v-spacer>
        <XIcon @click="$emit('input', false)" size="24" class="cursor-pointer mr-4 mt-2"/>
      </v-card-title>
      <v-card-text>
        <div class="d-flex flex-no-wrap menu-content">
          <div ref="preview-wrapper" class="form-preview__wrapper">
            <f-aspect-ratio-keeper width="16" height="9">
              <div class="form-preview">
                <div class="form-preview-scaler">
                  <EmbeddedFormPreview
                      :formJSON="formJSON"
                      :static-form-scale="staticFormScale"
                      :is-form-static="isFormStatic"
                      :is-form-interactive="isFormInteractive"
                      :fsp-module-location-path="fspModuleLocationPath"
                      :interactive-form-scale="interactiveFormScale"
                  />
                </div>
              </div>
            </f-aspect-ratio-keeper>
          </div>
          <div class="share-content">
            <v-card-subtitle class="align-center pb-0 grayscale_black--text d-flex flex-row">
              <slot name="subtitle">
              </slot>
            </v-card-subtitle>
            <v-card-title
                class="grayscale_black--text pt-2"

            >
              <slot name="title">

              </slot>
            </v-card-title>
            <v-card-subtitle class="grayscale_black--text">
              Get the link

            </v-card-subtitle>
            <v-text-field class="px-4" ref="link" flat solo outlined persistent-hint :value="shareLink" @copy="onCopy"
                          :hint="copied? 'Copied!' : ''" readonly
                          @focus="$event.target.select()">
              <template slot="append">
                <v-btn fab icon @click="copy">
                  <CopyIcon/>
                </v-btn>
              </template>
            </v-text-field>
            
            <!-- QR Code Section -->
       
            <v-card-subtitle class="grayscale_black--text">
              Or share with the world
            </v-card-subtitle>
            <div class="share-content__icons icons">
              <v-btn v-for="(item, index) in shareIcons"
                     :key="index"
                     :href="item.URL"
                     target="_blank"
                     class="pa-0 icons__social"
              >
                <v-icon
                    size="42"
                >
                  {{ item.icon }}
                </v-icon>
              </v-btn>
              <div class="qr-code-section mt-2 mb-2">
              <div class="d-flex justify-center">
                <v-btn 
                  @click="showQRModal"
                  class="qr-code-btn"
                  icon
                  small
                >
                  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.5156 17.7188H18.1406C17.9076 17.7188 17.7188 17.9076 17.7188 18.1406V21.5156C17.7188 21.7486 17.9076 21.9375 18.1406 21.9375H21.5156C21.7486 21.9375 21.9375 21.7486 21.9375 21.5156V18.1406C21.9375 17.9076 21.7486 17.7188 21.5156 17.7188Z" fill="black"/>
                    <path d="M17.2969 14.3438H14.7656C14.5326 14.3438 14.3438 14.5326 14.3438 14.7656V17.2969C14.3438 17.5299 14.5326 17.7188 14.7656 17.7188H17.2969C17.5299 17.7188 17.7188 17.5299 17.7188 17.2969V14.7656C17.7188 14.5326 17.5299 14.3438 17.2969 14.3438Z" fill="black"/>
                    <path d="M24.8906 21.9375H22.3594C22.1264 21.9375 21.9375 22.1264 21.9375 22.3594V24.8906C21.9375 25.1236 22.1264 25.3125 22.3594 25.3125H24.8906C25.1236 25.3125 25.3125 25.1236 25.3125 24.8906V22.3594C25.3125 22.1264 25.1236 21.9375 24.8906 21.9375Z" fill="black"/>
                    <path d="M24.8906 14.3438H23.2031C22.9701 14.3438 22.7812 14.5326 22.7812 14.7656V16.4531C22.7812 16.6861 22.9701 16.875 23.2031 16.875H24.8906C25.1236 16.875 25.3125 16.6861 25.3125 16.4531V14.7656C25.3125 14.5326 25.1236 14.3438 24.8906 14.3438Z" fill="black"/>
                    <path d="M16.4531 22.7812H14.7656C14.5326 22.7812 14.3438 22.9701 14.3438 23.2031V24.8906C14.3438 25.1236 14.5326 25.3125 14.7656 25.3125H16.4531C16.6861 25.3125 16.875 25.1236 16.875 24.8906V23.2031C16.875 22.9701 16.6861 22.7812 16.4531 22.7812Z" fill="black"/>
                    <path d="M23.625 1.6875H16.0312C15.5837 1.6875 15.1545 1.86529 14.838 2.18176C14.5215 2.49822 14.3438 2.92745 14.3438 3.375V10.9688C14.3438 11.4163 14.5215 11.8455 14.838 12.162C15.1545 12.4785 15.5837 12.6562 16.0312 12.6562H23.625C24.0726 12.6562 24.5018 12.4785 24.8182 12.162C25.1347 11.8455 25.3125 11.4163 25.3125 10.9688V3.375C25.3125 2.92745 25.1347 2.49822 24.8182 2.18176C24.5018 1.86529 24.0726 1.6875 23.625 1.6875ZM21.9375 8.85938C21.9375 8.97126 21.8931 9.07857 21.8139 9.15769C21.7348 9.2368 21.6275 9.28125 21.5156 9.28125H18.1406C18.0287 9.28125 17.9214 9.2368 17.8423 9.15769C17.7632 9.07857 17.7188 8.97126 17.7188 8.85938V5.48438C17.7188 5.37249 17.7632 5.26518 17.8423 5.18606C17.9214 5.10695 18.0287 5.0625 18.1406 5.0625H21.5156C21.6275 5.0625 21.7348 5.10695 21.8139 5.18606C21.8931 5.26518 21.9375 5.37249 21.9375 5.48438V8.85938ZM10.9688 1.6875H3.375C2.92745 1.6875 2.49822 1.86529 2.18176 2.18176C1.86529 2.49822 1.6875 2.92745 1.6875 3.375V10.9688C1.6875 11.4163 1.86529 11.8455 2.18176 12.162C2.49822 12.4785 2.92745 12.6562 3.375 12.6562H10.9688C11.4163 12.6562 11.8455 12.4785 12.162 12.162C12.4785 11.8455 12.6562 11.4163 12.6562 10.9688V3.375C12.6562 2.92745 12.4785 2.49822 12.162 2.18176C11.8455 1.86529 11.4163 1.6875 10.9688 1.6875ZM9.28125 8.85938C9.28125 8.97126 9.2368 9.07857 9.15769 9.15769C9.07857 9.2368 8.97126 9.28125 8.85938 9.28125H5.48438C5.37249 9.28125 5.26518 9.2368 5.18606 9.15769C5.10695 9.07857 5.0625 8.97126 5.0625 8.85938V5.48438C5.0625 5.37249 5.10695 5.26518 5.18606 5.18606C5.26518 5.10695 5.37249 5.0625 5.48438 5.0625H8.85938C8.97126 5.0625 9.07857 5.10695 9.15769 5.18606C9.2368 5.26518 9.28125 5.37249 9.28125 5.48438V8.85938ZM10.9688 14.3438H3.375C2.92745 14.3438 2.49822 14.5215 2.18176 14.838C1.86529 15.1545 1.6875 15.5837 1.6875 16.0312V23.625C1.6875 24.0726 1.86529 24.5018 2.18176 24.8182C2.49822 25.1347 2.92745 25.3125 3.375 25.3125H10.9688C11.4163 25.3125 11.8455 25.1347 12.162 24.8182C12.4785 24.5018 12.6562 24.0726 12.6562 23.625V16.0312C12.6562 15.5837 12.4785 15.1545 12.162 14.838C11.8455 14.5215 11.4163 14.3438 10.9688 14.3438ZM9.28125 21.5156C9.28125 21.6275 9.2368 21.7348 9.15769 21.8139C9.07857 21.8931 8.97126 21.9375 8.85938 21.9375H5.48438C5.37249 21.9375 5.26518 21.8931 5.18606 21.8139C5.10695 21.7348 5.0625 21.6275 5.0625 21.5156V18.1406C5.0625 18.0287 5.10695 17.9214 5.18606 17.8423C5.26518 17.7632 5.37249 17.7188 5.48438 17.7188H8.85938C8.97126 17.7188 9.07857 17.7632 9.15769 17.8423C9.2368 17.9214 9.28125 18.0287 9.28125 18.1406V21.5156Z" fill="black"/>
                  </svg>
                </v-btn>
              </div>
            </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- QR Code Modal Component -->
    <QRCodeModal 
      v-model="qrModalVisible" 
      :share-link="shareLink" 
    />
  </div>
</template>

<script>
import {computed, ref, onMounted} from "@vue/composition-api";
import QRCode from 'qrcode';

export default {
  name: "ShareFormMenu",
  components: {
    XIcon: () => import('vue-feather-icons/icons/XIcon'),
    CopyIcon: () => import('vue-feather-icons/icons/CopyIcon'),
    EmbeddedFormPreview: () => import('@/components/Dashboard/EmbeddedFormPreview/EmbeddedFormPreview'),
    QRCodeModal: () => import('@/components/Elements/QRCodeModal'),
  },
  props: {
    value: Boolean,

    shareLink: {
      type: String,
      required: true,
    },
    formJSON: {
      type: Object,
      required: true,
    },
    isFormStatic: {
      type: Boolean,
      required: true,
    },
    isFormInteractive: {
      type: Boolean,
      required: true,
    },
    fspModuleLocationPath: {
      type: String,
      required: true,
    }
  },
  data: () => ({
    copied: false,
    qrCodeDataUrl: '',
    qrError: false,
    qrLoading: true,
    qrModalVisible: false,
  }),
  setup(props, {root, refs}) {
    const containerWidth = ref(1920)

    const resizeObserver = root.Utils.useResizeObserver(([{contentRect: {width}}]) => containerWidth.value = width)
    onMounted(() => {
      if (refs['preview-wrapper']) {
        resizeObserver.unobserveAll()
        resizeObserver.observe(refs['preview-wrapper'])
      }
    })
    const formatScaleToStylelike = scale => ({transform: `scale(${scale})`})


    const staticFormScale = computed(() => formatScaleToStylelike(containerWidth.value / 1300))
    const interactiveFormScale = computed(() => formatScaleToStylelike(containerWidth.value / 1920))
    const encodedURIComponentURL =  window.encodeURIComponent(`${props.shareLink}`)
    //console.log(process.env.VUE_APP_FACEBOOK_APP_ID);
    const shareIcons = [
      // {
      //   icon: '$linkedin',
      //   URL: `https://www.linkedin.com/shareArticle?url=${encodedURIComponentURL}`
      // },
      {
        icon: '$twitter',
        URL: `https://twitter.com/intent/tweet?url=${encodedURIComponentURL}`,
      },
      {
        icon: '$whatsapp',
        URL: `https://api.whatsapp.com/send?text=${encodedURIComponentURL}`
      },
      // {
      //   icon: '$facebook',
      //   URL: `https://www.facebook.com/dialog/share?app_id=${window.encodeURIComponent(process.env.VUE_APP_FACEBOOK_APP_ID)}&display=${window.encodeURIComponent('popup')}&href=${window.encodeURIComponent(props.shareLink)}`,
      // },
      {
        icon: '$telegram',
        URL: `https://t.me/share/url?url=${encodedURIComponentURL}`
      },
    ];


    return {
      staticFormScale,
      interactiveFormScale,
      shareIcons
    }
  },
  watch: {
    value(v) {
      if (v)
        document.addEventListener('keyup', this.listenKeypress)
      else
        document.removeEventListener('keyup', this.listenKeypress)
    }
  },
  mounted() {
    this.generateQRCode()
  },
  methods: {
    onCopy() {
      this.copied = true
    },
    copy() {
      this.$refs.link.focus();
      document.execCommand('copy');
      this.copied = true
    },
    listenKeypress(evt) {
      if (evt.key === 'Escape')
        this.$emit('input', false)
    },
    async generateQRCode() {
      try {
        this.qrLoading = true
        this.qrError = false
        
        // Generate QR code as data URL with custom options
        this.qrCodeDataUrl = await QRCode.toDataURL(this.shareLink, {
          width: 100,
          margin: 1,
          color: {
            dark: '#000000', // Black dots
            light: '#FFFFFF' // White background
          },
          errorCorrectionLevel: 'M'
        })
        
        this.qrLoading = false
      } catch (error) {
        console.error('Error generating QR code:', error)
        this.qrError = true
        this.qrLoading = false
      }
    },
    onQrError() {
      this.qrError = true
      this.qrLoading = false
    },
    onQrLoad() {
      this.qrLoading = false
    },
    showQRModal() {
      this.qrModalVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.share-form-menu {
  height: 100%;
  border-radius: 0 !important;
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(50px);
  box-shadow: 0px 12px 16px -12px rgba(16, 24, 40, 0.07),
  0px 4px 6px -4px rgba(16, 24, 40, 0.05) !important;


  .menu-content {
    place-content: center;
    column-gap: 58px;


    .share-content {
      position: relative;

      .qr-code-btn {
        min-width: 42px !important;
        border-radius: 6px !important;
        
        svg {
          position: relative;
          bottom: 2px;
          fill: #666;
          width: 43px;
          height: 43px;
        }
      }

      & > * {
        padding: 0 !important;
      }

      .v-card__title {
        margin: 0 0 24px;

        & + .v-card__subtitle {
          margin: 0 0 9px;
        }
      }

      .v-text-field {
        ::v-deep .v-input__slot {
          margin-bottom: 0;
        }

        ::v-deep input {
          color: var(--v-blue_400-base);
          font-weight: 500;
        }
      }

      &__icons {
        margin: 8px 0 0;
        display: flex;
        column-gap: 10px;

        .v-icon {
          cursor: pointer;
        }
      }
      .icons {
        &__social {
          min-width: 0;
          padding: 0 !important;
        }
      }


    }

    .form-preview__wrapper {
      flex: 0 1 350px;
      display: flex;
    }

    .form-preview {
      display: flex;
      height: 100%;
      justify-content: center;

      &-scaler {
        width: 1920px;
        height: 1080px;
        transform-origin: top;
        flex: 1 0 1920px;
      }
    }
  }
}
</style>
